var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import * as i18nActions from "./i18n.actions";
export var REDUCER_KEY_I18N = "i18n";
var getDefaultState = function () { return ({
    locale: undefined,
}); };
var reducer = createReducer({}, getDefaultState());
reducer.on(i18nActions.setLocale, function (state, locale) { return (__assign(__assign({}, state), { locale: locale })); });
export default reducer;
